import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { FilterService } from 'libs/portal/src/services/filter/filter.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-terminal-filter',
  templateUrl: './terminal-filter.component.html',
  styleUrls: ['./terminal-filter.component.scss'],
})
export class TerminalFilterComponent implements OnInit, OnDestroy {
  constructor(private filterService: FilterService) {}

  form = new UntypedFormGroup({
    terminalControl: new UntypedFormControl('', [Validators.required]),
  });

  sub: Subscription;

  filter() {
    const filterObj = {
      status: null,
      bundle: null,
      merchants: null,
      terminal: this.form.get('terminalControl')?.value,
      lastUpdate: null,
    };
    this.filterService.emit(filterObj);
  }

  ngOnInit() {
    this.sub = this.filterService.searchClickedEvent.subscribe((clicked) => {
      if (clicked) {
        this.filter();
      }
    });
  }

  ngOnDestroy(): void {
      this.sub?.unsubscribe();
  }
}
